export default function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <div>
        {overline && <p className="text-xs tracking-overline text-[#C62828] font-semibold mb-2">{overline}</p>}
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#121212]" data-testid="page-title">{title}</h1>
        {description && <p className="text-[#616161] mt-2 text-sm max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
